export default {
  username: {
    rule1: '请输入用户名',
    rule2: '用户名至少为 5 位字符',
    rule3: '用户名最多为 30 位字符',
    rule4: '用户名须以字母开头，且只能包含字母、数字、横线及下划线',
    rule5: '用户名已存在',
    rule6: '用户名不存在'
  },
  common: {
    rulemaxlen30: '最多为 30 位字符'
  },
  name: {
    rule1: '请输入用户名/邮箱',
    rule2: '请输入正确的用户名/邮箱'
  },
  email: {
    rule1: '请输入邮箱地址',
    rule2: '请输入正确的邮箱地址'
  },
  password: {
    rule1: '请输入密码',
    rule2: '密码长度至少6位'
  },
  confirm: {
    rule1: '请再次输入密码',
    rule2: '两次输入密码不一致!'
  },
  mobile: {
    rule1: '请输入手机号',
    rule2: '手机号码已存在',
    rule3: '请输入正确手机号，目前只支持中国大陆的手机号码',
    rule4: '手机号码不存在'
  },
  code: {
    rule1: '请输入验证码',
    rule2: '请输入正确验证码'
  },
  agree: {
    rule1: '请勾选同意协议'
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh/public/validator.js